import { InfoCircleOutlined } from '@ant-design/icons'
import { Button, ButtonProps, Modal } from 'antd'
import React, { FunctionComponent, memo } from 'react'

import { useToggleState } from '../../utils/useToggleState'
import { AuctionMonitoringLinkedPropertyHelp } from '../AuctionMonitoringLinkedPropertyHelp/AuctionMonitoringLinkedPropertyHelp'

export interface AuctionMonitoringLinkedPropertyHelpModalButtonProps {
  buttonProps?: ButtonProps
  defaultActiveKey?: string
  buttonText?: string
}

const okButtonProps = {
  style: {
    display: 'none',
  },
}

export const AuctionMonitoringLinkedPropertyHelpModalButton: FunctionComponent<AuctionMonitoringLinkedPropertyHelpModalButtonProps> =
  memo(props => {
    const [open, toggleModal] = useToggleState()

    return (
      <>
        <Button
          icon={<InfoCircleOutlined />}
          type="link"
          onClick={toggleModal}
          {...props.buttonProps}
        >
          {props.buttonText || 'Zobrazit nápovědu'}
        </Button>

        {open && (
          <Modal
            title="Nápověda: Párování dražby s nemovitostí"
            open={open}
            width={800}
            onCancel={toggleModal}
            cancelText="Zavřít nápovědu"
            okButtonProps={okButtonProps}
          >
            <AuctionMonitoringLinkedPropertyHelp
              defaultActiveKey={props.defaultActiveKey}
            />
          </Modal>
        )}
      </>
    )
  })
